// App Creator AI Tool System - Extends AIToolSystem for app creator-specific AI tools
// Provides app creator context for AI tool sets

import { AIToolSystem } from "../../../base/AIToolSystem.js";

export class AppCreatorAIToolSystem extends AIToolSystem {}